const AbstractData = [
    {
        title: "Emotions and Feelings",
        words: ["Love", "Joy", "Sorrow", "Fear", "Empathy", "Compassion", "Jealousy", "Apathy", "Passion", "Optimism", "Pessimism", "Insecurity", "Loneliness", "Connection", "Frustration", "Disappointment", "Indifference"]
    },
    {
        title: "Moral and Ethical Concepts",
        words: ["Justice", "Morality", "Ethics", "Virtue", "Sin", "Enlightenment", "Greed", "Generosity", "Prejudice", "Bias", "Ignorance", "Tolerance", "Intolerance", "Honor", "Disgrace", "Respect", "Disrespect"]
    },
    {
        title: "Philosophical Concepts",
        words: ["Truth", "Reality", "Illusion", "Consciousness", "Memory", "Perception", "Certainty", "Uncertainty", "Existence", "Nonexistence", "Life", "Death", "Eternity", "Transience", "Meaning", "Purpose", "Absurdity", "Logic", "Reason", "Emotion", "Intention", "Motivation"]
    },
    {
        title: "Societal and Political Concepts",
        words: ["Freedom", "Democracy", "Tyranny", "Leadership", "Followership", "Heroism", "Villainy", "Wealth", "Poverty", "Abundance", "Scarcity", "Altruism", "Egoism", "Revolution", "Rebellion", "Conformity", "Individuality"]
    },
    {
        title: "Aesthetic and Creative Concepts",
        words: ["Beauty", "Creativity", "Imagination", "Intuition", "Curiosity", "Inspiration", "Symbolism", "Metaphor", "Irony", "Paradox", "Comedy", "Tragedy"]
    },
    {
        title: "Temporal and Existential Concepts",
        words: ["Time", "Destiny", "Infinity", "Balance", "Harmony", "Chance", "Fate", "Luck", "Risk", "Simplicity", "Complexity", "Authenticity", "Pretense", "Innocence", "Experience", "Maturity", "Naivety", "Wisdom", "Foolishness", "Reality", "Fantasy", "Dream", "Nightmare", "Legend", "Myth", "Evolution", "Stagnation", "Progress", "Decline", "Success", "Failure", "Victory", "Defeat"]
    },
    {
        title: "Relational Concepts",
        words: ["Trust", "Loyalty", "Unity", "Division", "Diversity", "Equality", "Acceptance", "Denial", "Satisfaction", "Frustration", "Connection", "Separation", "Inclusion", "Exclusion", "Rejection", "Attraction", "Repulsion", "Proximity", "Distance", "Similarity", "Difference", "Convergence", "Divergence", "Synthesis"]
    },
    {
        title: "Cognitive and Behavioral Concepts",
        words: ["Knowledge", "Power", "Wisdom", "Courage", "Faith", "Hope", "Discipline", "Sacrifice", "Gratitude", "Resilience", "Persistence", "Patience", "Ambition", "Doubt", "Regret", "Guilt", "Shame", "Pride", "Humility", "Acceptance", "Chance"]
    }
];

const ConcreteData = [
    {
        title: "Furniture",
        words: ["Chair", "Table", "Bed", "Desk", "Couch", "Coffee table", "Rug", "Bedside table", "Lamp"]
    },
    {
        title: "Household Items",
        words: ["Cup", "Plate", "Fork", "Spoon", "Knife", "Bottle", "Glass", "Mirror", "Oven", "Fridge", "Microwave", "Toaster", "Sink", "Bathtub", "Toilet", "Towel", "Soap", "Toothbrush", "Toothpaste", "Shampoo", "Conditioner", "Vacuum cleaner", "Iron", "Washing machine", "Dryer", "Broom", "Dustpan", "Trash can"]
    },
    {
        title: "Electronics",
        words: ["Computer", "Phone", "Television", "Camera", "Guitar", "Remote control", "Headphones", "Alarm clock"]
    },
    {
        title: "Office Supplies",
        words: ["Pen", "Pencil", "Eraser", "Notebook", "Marker", "Highlighter", "Calculator", "Stapler", "Tape", "Scissors", "Glue", "Clipboard", "Chalkboard", "Whiteboard"]
    },
    {
        title: "Outdoor/Nature",
        words: ["Tree", "Flower", "Ball", "Pillow", "Plant"]
    },
    {
        title: "Clothing and Accessories",
        words: ["Shoe", "Shirt", "Pants", "Jacket", "Ring", "Watch", "Hat", "Bag", "Backpack"]
    },
    {
        title: "Tools",
        words: ["Hammer", "Screwdriver", "Nail", "Magnifying glass", "Binoculars", "Telescope", "Compass"]
    },
    {
        title: "Transportation",
        words: ["Car", "Bicycle", "Key", "Wallet"]
    },
    {
        title: "Books and Media",
        words: ["Book", "Map", "Globe"]
    },
    {
        title: "Miscellaneous",
        words: ["Dog", "Cat", "Vase", "Painting", "Picture frame", "Stove", "Blender"]
    }
];

export {
    AbstractData, ConcreteData
}